'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { Fragment } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import { widowKiller } from 'utils';

import TextThemed from './TextThemed';

import styles from './Text.module.scss';

const processNewlineBreaks = (children, parentIndex) => fixWidows => {
    const setLineBreak = (e, i) => {
        if (typeof children === 'string') {
            return i < children.split('\n').length - 1
                ? [e, <br key={`line-break-${parentIndex}-${i}`} />]
                : e;
        }
        return e;
    };

    switch (typeof children) {
        case 'string':
            if (children?.trim() === '') {
                return null;
            }

            // confirm children is a string
            const stringChildren = children;
            // use empty string as fallback if widowKiller returns null/undefined
            const processedText = fixWidows
                ? widowKiller(stringChildren) || ''
                : stringChildren;

            return (
                <Fragment key={`fragment-${parentIndex}`}>
                    {processedText
                        .split('\n')
                        .map((item, i) => setLineBreak(item, i))}
                </Fragment>
            );
        case 'object':
            if (Array.isArray(children)) {
                return children.map((child, idx) => {
                    // avoid adding double space before hyperlinked text
                    if (
                        React.isValidElement(children[idx + 1]) &&
                        'href' in children[idx + 1].props
                    ) {
                        return child;
                    }

                    return processNewlineBreaks(child, idx)(fixWidows);
                });
            }
            return children;
        default:
            return children;
    }
};

const Text = React.forwardRef(
    (
        {
            as: Tag = 'span',
            baseTheme,
            themes,
            className,
            children,
            fixWidows = false,
            ...otherProps
        },
        ref
    ) => {
        if (children === '') {
            return null;
        }
        if (Array.isArray(children) && children.every(child => child === '')) {
            return null;
        }

        const childrenWithBreaks = processNewlineBreaks(children, 0)(fixWidows);

        const themesArray = [];

        if (themes) {
            Object.keys(themes).forEach(key => {
                themesArray.push(styles[`${key}--${themes[key]}`]);
            });
        }

        const Component = Tag;

        return (
            <Component
                {...otherProps}
                ref={ref}
                className={cx(
                    styles[`base--${baseTheme}`] || '',
                    ...themesArray,
                    className
                )}
            >
                {childrenWithBreaks}
            </Component>
        );
    }
);

Text.propTypes = {
    as: PropTypes.string,
    baseTheme: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    fixWidows: PropTypes.bool,
    themes: PropTypes.object,
};

Text.Theme = TextThemed;

export default Text;
